/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Http_HintInputs */

const vi_shop_home_http_hint = /** @type {(inputs: Shop_Home_Http_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu bằng http:// hoặc https://`)
};

/**

* @param {Shop_Home_Http_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_http_hint = /** @type {((inputs?: Shop_Home_Http_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Http_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_http_hint(inputs)
});